import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Menu.css";

function Menu() {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <>
      {/* BOTÓN */}
      <div className="burger" onClick={() => setOpen(true)}>
        ☰
      </div>

      {/* OVERLAY */}
      <div className={`menu-overlay ${open ? "open" : ""}`}>
        <div className="menu-content">
          <span className="close" onClick={handleClose}>×</span>

          <ul>
            <li><Link to="/" onClick={handleClose}>Inicio</Link></li>
            <li><Link to="/desarrollo-web" onClick={handleClose}>Desarrollo Web</Link></li>
            <li><Link to="/cms" onClick={handleClose}>CMS</Link></li>
            <li><Link to="/ecommerce" onClick={handleClose}>E-commerce</Link></li>
            <li><Link to="/inteligencia-artificial" onClick={handleClose}>Inteligencia Artificial</Link></li>
            <li><Link to="/marketing-digital" onClick={handleClose}>Marketing Digital</Link></li>
            <li><Link to="/optimizacion-web" onClick={handleClose}>Optimización Web</Link></li>
            {/* opcional */}
            {/* <li><Link to="/contacto" onClick={handleClose}>Contacto</Link></li> */}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Menu;